import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import posed from 'react-pose'

const Image = styled.img`
  ${props => (props.position === 'right' ? 'margin-left: 16px;' : null)}
  ${props => (props.position === 'left' ? 'margin-right: 16px;' : null)}
`

const Box = posed.button({
  hoverable: true,
  pressable: true,
  focusable: true,
  init: {
    scale: 1,
    boxShadow: '0 9px 24px 0 rgba(98,211,109,0.39)'
  },
  focus: {
    scale: 1.03,
    boxShadow: '0 24px 24px 0 rgba(98,211,109,0.39)'
  },
  hover: {
    scale: 1.03,
    boxShadow: '0 24px 24px 0 rgba(98,211,109,0.39)'
  },
  press: {
    scale: 0.95,
    boxShadow: '0 9px 24px 0 rgba(98,211,109,0.05)'
  }
})

const StyledBox = styled(Box)`
  border: none;
  -webkit-tap-highlight-color: transparent;
  background: linear-gradient(-135deg, #71d77c 0%, #5ac866 100%);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-width: 140px;
  height: 60px;
  padding: 17px;
  cursor: pointer;
  color: #ffffff;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  font-size: 1.125rem;
  user-select: none;
  transition: all 0.5s ease;
  ${props => (props.disabled ? 'opacity: 0.5;' : 'opacity: 1;')}
`
const GreenButton = ({
  onClick,
  text,
  image,
  position,
  isMobile,
  disabled
}) => {
  const imgProps = {
    position,
    src: image
  }

  return (
    <StyledBox isMobile={isMobile} onClick={onClick} disabled={disabled}>
      {image && position === 'left' ? <Image {...imgProps} /> : null}
      {text}
      {image && position === 'right' ? <Image {...imgProps} /> : null}
    </StyledBox>
  )
}

GreenButton.defaultProps = {
  position: 'right',
  isMobile: false,
  image: null
}

GreenButton.propTypes = {
  isMobile: PropTypes.bool,
  position: PropTypes.oneOf(['left', 'right']),
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.string
}

export default GreenButton
